import { FC } from 'react';
import Script from 'next/script';
/**
 * 12-Mar-21: To help diagnose a production issue with nginx SSI we are
 * directly inlining the html and script snippets here
 */
import htmlRebrand from './assets/rebrand.html.txt';

const ConsentBanner: FC = () => {
    if (process.env['NODE_ENV'] !== 'production') {
        return null;
    }

    const useLiveRamp = process.env['NEXT_PUBLIC_DISABLE_LIVERAMP'] !== '1';

    return useLiveRamp ? (
        <Script
            src={process.env['NEXT_PUBLIC_LIVERAMP_CMP_SCRIPT_URL']}
            strategy="beforeInteractive"
        />
    ) : (
        <div
            data-testid="consent-banner"
            dangerouslySetInnerHTML={{
                __html: htmlRebrand.replace(
                    '{{segmentID}}',
                    process.env['NEXT_PUBLIC_SEGMENT_ID'] ?? ''
                )
            }}
        />
    );
};

export default ConsentBanner;
